import React from "react";
import {
  Button,
  Grid,
  MenuItem,
  InputLabel,
  FormControl,
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { Formik, Form, Field } from "formik";
import { TextField, Select } from "formik-material-ui";
import { KeyboardDatePicker } from "formik-material-ui-pickers";
import MuiPhoneNumber from "material-ui-phone-number";
import DateFnsUtils from "@date-io/date-fns";
import * as Yup from "yup";
import { countries } from "../../listOfCountries";

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText("#29479a"),
    backgroundColor: "#29479a",
    width: "auto",
    minWidth: "150px",
    borderRadius: "25px",
    marginTop: "10px",
    "&:hover": {
      backgroundColor: "#294780",
    },
  },
}))(Button);

const infoSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  role: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  experience: Yup.string().required("Required"),
  nationality: Yup.string().required("Required"),
  phone: Yup.number().required("Required"),
  birthday: Yup.string().required("Required"),
  location: Yup.string().required("Required"),
  github: Yup.string()
    .matches(/((https?):\/\/)?((www)?\.)?(github.com)\//y,"your GitHub profile URL")
    .required("Required"),
  linkedin: Yup.string()
    .matches(/((https?):\/\/)?((www)?\.)?(linkedin.com)\//y,"your GitHub profile URL")
    .required("Required"),
  bio: Yup.string().required('Required').max(200, "only 200 characters")
});

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 180,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  textArea:{
    width: '81%'
  },
  mt: {
    marginTop: '5px'
  }
}));

function EditGeneralInfo(props) {
  const classes = useStyles();
  const talent = {
    id: props.talent && props.talent.id,
    name: props.talent && props.talent.name,
    role: props.talent && props.talent.role,
    experience: props.talent && props.talent.experience,
    nationality: props.talent && props.talent.nationality,
    location: props.talent && props.talent.location,
    email: props.talent && props.talent.email,
    phone: props.talent && props.talent.phone,
    birthday: props.talent.birthday ? props.talent.birthday : new Date(),
    linkedin: props.talent && props.talent.linkedin,
    github: props.talent && props.talent.github,
    bio: props.talent && props.talent.bio
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    /*
     * add the talent id with the updated values
     * to match the endpoint in the backend
     */
    console.log(values);
    values.id = talent.id;
    fetch(process.env.REACT_APP_IP + '/talent/data/' + talent.id, {
      method: "PATCH",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.error) {
          console.log(res.message);
          setSubmitting(false);
        } else {
          props.refresh();
          props.update();
        }
      });
  };

  return (
    <>
      <Formik
        initialValues={{
          name: talent.name,
          role: talent.role,
          experience: talent.experience,
          nationality: talent.nationality,
          location: talent.location,
          email: talent.email,
          phone: talent.phone,
          birthday: talent.birthday,
          linkedin: talent.linkedin,
          github: talent.github,
          bio: talent.bio
        }}
        validationSchema={infoSchema}
        onSubmit={(values, { setSubmitting }) => {
          handleSubmit(values, { setSubmitting });
        }}
      >
        {({ submitForm, isSubmitting, setFieldValue, values }) => (
          <Form>
            <h4><strong>General Info</strong></h4>
            <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            >
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <Field
                  required
                  name="name"
                  component={TextField}
                  id="name-required"
                  label="Name"
                />
              </Grid>
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Field
                  required
                  name="birthday"
                  component={KeyboardDatePicker}
                  format="MM/dd/yyyy"
                  id="birthday-required"
                  label="Date of birth"
                  />
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <Field
                required
                name="role"
                component={TextField}
                id="role-required"
                label="Role"
                />
              </Grid>
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="experience">Experience</InputLabel>
                  <Field
                  required
                  component={Select}
                  name="experience"
                  inputProps={{
                    id: "experience",
                  }}
                  >
                    <MenuItem value={"1 - 3"}>1 - 3</MenuItem>
                    <MenuItem value={"3 - 5"}>3 - 5</MenuItem>
                    <MenuItem value={"5 - 7"}>5 - 7</MenuItem>
                    <MenuItem value={"7 - 10"}>7 - 10</MenuItem>
                    <MenuItem value={"10 - 15"}>10 - 15</MenuItem>
                    <MenuItem value={"+15"}> +15</MenuItem>
                  </Field>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="nationality">Nationality</InputLabel>
                  <Field
                  required
                  component={Select}
                  name="nationality"
                  inputProps={{
                    id: "nationality",
                  }}
                  >
                    {countries.map((country, index) => (
                      <MenuItem key={index} value={country}>
                        {country}
                      </MenuItem>
                    ))}
                  </Field>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="location">Location</InputLabel>
                  <Field
                  required
                  component={Select}
                  name="location"
                  inputProps={{
                    id: "location",
                  }}
                  >
                    {countries.map((country, index) => (
                      <MenuItem key={index} value={country}>
                        {country}
                      </MenuItem>
                    ))}
                  </Field>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={10} md={12} sm={10}>
                <Field className={classes.textArea}
                required
                name="bio"
                component={TextField}
                id="bio-required"
                label="Bio"
                multiline
                rows={2}
                helperText="max 200 characters"
                placeHolder=""
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item xs={12}>
                <h4 className={classes.mt}>
                  <strong>Contact Info</strong>
                </h4>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <Field
                  name="email"
                  component={TextField}
                  id="email-required"
                  disabled
                  label="Email"
                />
              </Grid>
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <MuiPhoneNumber
                  name="phone"
                  label="Mobile Number"
                  id="phone"
                  value={values.phone}
                  disableAreaCodes="true"
                  defaultCountry="eg"
                  onChange={(value) => setFieldValue("phone", value)}
                />
              </Grid>
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <Field
                  name="github"
                  component={TextField}
                  id="github-required"
                  label="Github"
                />
              </Grid>
              <Grid item xs={12} lg={5} md={6} sm={10}>
                <Field
                  name="linkedin"
                  component={TextField}
                  id="linkedin-required"
                  label="LinkedIn"
                />
              </Grid>
            </Grid>
            <Grid container direction="row" justify="flex-end">
              <Grid item>
                <ColorButton disabled={isSubmitting} onClick={submitForm}>
                  Update
                </ColorButton>
              </Grid>
              <Grid item style={{ width: 10 }}></Grid>
              <Grid item>
                <ColorButton disabled={isSubmitting} onClick={props.update}>
                  cancel
                </ColorButton>
              </Grid>
              <Grid item style={{ width: 10 }}></Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default EditGeneralInfo;
